angular.module('harriApp')
    .controller('OfferController', ["$scope", "hUser", "$stateParams", "$state", "registrationApi", "$rootScope", "hEvent", "wotcDataService", function ($scope, hUser, $stateParams, $state, registrationApi, $rootScope, hEvent, wotcDataService) {

        MemberAPI.getProfile(hUser.data.user.id).then(function(memberDetails) {
            $scope.memberDetails = memberDetails;
        });

        $scope.brand = null;
        $scope.job = null;
        $scope.offer = null;
        $scope.memberId = hUser.data.user.id;
        $scope.showOffer = false;
        $scope.inTeamlive = $state.current.name.indexOf('appLayout.schedule.') === 0;

        var offer_id = $stateParams.doc_id;

        var offer_params = {
            document_id: offer_id,
            state: OnBoardingAPI.appStatuses.REQUESTED,
            doc_type: OnBoardingAPI.DOCUMENT_TYPE.OFFER
        };

        $scope.whenVerificationFinished = function($event) {
            $scope.showOffer = $event.verified;
            if ($event.verified) {
                $scope.init();
            }
        };
        const checkWotcExists = async () => {
            let canCompleteWotc = false;
            let walkinCandidateScreeningExists;
            try {
                let candidatesScreening = await wotcDataService.getCandidateScreenings([wotcDataService.WOTC_STATUS.OPEN, wotcDataService.WOTC_STATUS.IN_PROGRESS, wotcDataService.WOTC_STATUS.WAITING_SIGN]);

                const walkinWotcScreening = candidatesScreening.prospects || [];
                walkinCandidateScreeningExists = walkinWotcScreening.find(wotcScreening => wotcScreening.prospect.id === $scope.offer.prospect_id);

                let applicationScreening = candidatesScreening.applications || [];
                let candidateScreeningExists = applicationScreening.find(wotcScreening => wotcScreening.job_application.id === $scope.offer.application_id);

                if (walkinCandidateScreeningExists || candidateScreeningExists) {
                    canCompleteWotc = true;
                }
            } catch (error) {
                console.error("Error checking WOTC exists:", error);
            }
            return {canCompleteWotc, walkinCandidateScreeningExists};
        }
        const checkIrs8850 = (data) => {
            return data.some(item => item.document.type === OnBoardingAPI.DOCUMENT_TYPE.IRS_8850 && item.document.state !== OnBoardingAPI.appStatuses.SIGNED && item.document.prospect_id === $scope.offer.prospect_id);
        };

        const navigateToWotc = (brandId, walkinCandidateScreeningExists, prospectId, appId) => {
            const params = walkinCandidateScreeningExists && prospectId
                ? {brand_id: brandId, prospect_id: prospectId, wotc_force: true}
                : {brand_id: brandId, app_id: appId, wotc_force: true};
            $state.go('.wotc', params);
        };

        const navigateToDocuments = (prospectId) => {
            $state.go("documents", {prospect_id: prospectId});
        };
        const checkWotcAndIris8850 = async () => {
            let reqParams = {
                state: "REQUESTED",
                category: "OFFER,ON_BOARDING,CANDIDATE_CUSTOM,POST_HIRE,RIGHT_TO_WORK,GFE,BRAND_CUSTOM",
                signed_url: true
            };
            try {
                const user_documents = await OnBoardingAPI.getOnboardingUserDocuments(reqParams);
                let ires8850Exist = checkIrs8850(user_documents);
                let {
                    canCompleteWotc,
                    walkinCandidateScreeningExists
                } = await checkWotcExists();
                if (canCompleteWotc) {
                    navigateToWotc($scope.brand.id, walkinCandidateScreeningExists, $scope.offer.prospect_id, $scope.offer.application_id);
                } else if (ires8850Exist) {
                    navigateToDocuments($scope.offer.prospect_id);
                }
                if (ires8850Exist && canCompleteWotc) {
                    navigateToWotc($scope.brand.id, walkinCandidateScreeningExists, $scope.offer.prospect_id, $scope.offer.application_id);
                    wotcDataService.on("on-wotc-status-change", () => {
                        if (ires8850Exist) {
                            navigateToDocuments($scope.offer.prospect_id);
                        }
                    });
                    wotcDataService.on("on-wotc-close", () => {
                        if (ires8850Exist) {
                            navigateToDocuments($scope.offer.prospect_id);
                        }
                    });
                }
            } catch (error) {
                console.error("Error processing WOTC and IRS 8850 check:", error);
            }
        }
        $scope.init = function () {
            $scope.loading = true;

            OnBoardingAPI.getOnboardingUserDocuments(offer_params)
                .then(function (docs) {

                    delete $scope.loading;

                    if (docs && docs.length == 1) {

                        $scope.job = docs[0].job;
                        $scope.brand = docs[0].brand;
                        $scope.offer = docs[0].document;
                        $scope.showActionButtons = hUser.isEmployer() ? ($scope.offer && !hUser.isLoggedInWithMagicToken()) : $scope.offer;
                        let promise;

                        OnBoardingAPI.getDocumentLink(offer_id)
                            .then(function (details) {
                                $scope.offer.link = details.link;
                                $scope.$digest();
                            },
                            function (err) {
                                console.error(err);
                            });

                        if ($scope.offer.application_id) {
                            promise = OnBoardingAPI.checkOnboardedByCarri($scope.brand.id, $scope.offer.application_id);
                        } else if ($scope.offer.prospect_id) {
                            promise = OnBoardingAPI.checkOnboardedByCarri($scope.brand.id, null, $scope.offer.prospect_id);
                        }

                        if (promise) {
                            promise.then(async function (onboardedByCarriDetails) {
                                    var onboardedByCarri = onboardedByCarriDetails.prospects && onboardedByCarriDetails.prospects[0] && onboardedByCarriDetails.prospects[0].onboarded_by_carri;
                                    $scope.onboarded_by_carri = onboardedByCarri;
                                    await checkWotcAndIris8850();
                                    $scope.$digest();
                                }).catch(function (err) {
                                    $scope.onboarded_by_carri = false;
                                    console.error(err);
                            }).finally(function () {
                                $scope.$digest();
                            });
                        }
                        else {
                            $scope.onboarded_by_carri = false;
                        }
                    }
                    else {
                        hRedirect('/404');
                    }
                },
                function (err) {
                    delete $scope.loading;

                    if (err?.status === 412) {
                        err.data.data = err.data.data || {};
                        $scope.verification_email = err.data.data.verification_email;
                        $scope.$digest();
                    }
                    else {
                        console.error(err);
                    }
                });
        };

        $scope.acceptOffer = function () {

            $scope.loading = true;

            OnBoardingAPI.candidateDocAction(offer_id, OnBoardingAPI.appStatuses.SIGNED)
                .then(function (res) {
                    delete $scope.loading;
                    $('#congratulations_offer').modal({backdrop: 'static', keyboard: false});
                },
                function (err) {
                    delete $scope.loading;
                    console.error(err);
                    hAlert($filter("translate")("Something Went Wrong"), $filter("translate")("Please try again later"));
                })
        };

        $scope.goToDashboard = function () {
            if ($('.modal-open').length) {
                $('.modal-open').removeClass('modal-open');
            }
            $('#congratulations_offer').modal('hide');
            $state.go("appLayout.harriSH.dashboard");
        };

        var setUserPhoto = function(uuid) {
            $scope.userPhotoNotSet = uuid? false: true;
            $scope.profilePhotoURL = MediaUtils.hUserProfileImage([uuid, $scope.memberId], '_icon_user_search', true);
            $scope.$digest();
        };

        /**
         * Upload image file to server
         *
         * @param filesToUpload
         * @param type
         * @param coords
         * @param onProgress
         * @returns {deferred.promise|{then, always}|{then}}
         */
        var doActualUpload = function(filesToUpload, type, coords, onProgress) {

            var deferred = $q.defer();
            onProgress = onProgress || function(file, percentage) {};

            //upload url
            var photoUploadURL = type;

            //add files to queue
            var photos = [];

            filesToUpload.forEach(function(file) {
                if (file.type && file.type.indexOf("image") >= 0) {
                    photos.push(file);
                }
            });

            $scope[type + "_loading"] = true;

            var uploadPromise = $scope.directUpload(photos, photoUploadURL, undefined, coords, onProgress);


            uploadPromise.then(function (res) {
                $scope[type + "_loading"] = false;

                if (res[0] && res[0].data && res[0].data.data) {
                    var imageData = res[0].data.data;

                    var image = registrationApi.generateUserPhoto(imageData, type);

                    deferred.resolve(image);
                }
            });

            return deferred.promise;
        };

        /**
         * Show image cropping modal for profile picture upload.
         */
        $scope.changeProfilePhoto = function(selectedFiles) {

            if (selectedFiles.length > 0 && selectedFiles[0]) {
                $rootScope.$broadcast('showImageCroppingModalLoading');

                setTimeout(function() {

                    var opt = {};
                    opt['file'] = selectedFiles[0];
                    opt['updateCoordsOnClose'] = true;
                    opt['croppingModalCallBack'] = function (coords, image) {
                        $scope.isUploadingProfileImage = true;

                        image.name = selectedFiles[0].name;
                        image.lastModifiedDate = selectedFiles[0].lastModifiedDate;

                        // Call photo upload when cropping tool is ready
                        doActualUpload([image], 'profile_photo', coords)
                            .then(function (image) {
                                setTimeout(function () {
                                    setUserPhoto(image.uuid);
                                    hEvent.track('profile_photo_upload', {category: 'offer_candidate', photo: 'profile'});
                                    $scope.goToDashboard();
                                    $scope.isUploadingProfileImage = false;
                                    $scope.$apply();
                                }, 1);
                            });
                    };

                    // send selected files && show modal
                    $rootScope.$broadcast('showImageCroppingModal', opt);

                }, 10);
            }
            else {
                console.warn("Cropping tool called without a file selected");
            }
        };

        $scope.declineOffer = function () {
            $scope.loading = true;

            hConfirm($filter("translate")("Are you sure you want to decline this offer?"), function (confirm) {

                if (confirm) {
                    OnBoardingAPI.candidateDocAction(offer_id, OnBoardingAPI.appStatuses.C_REJECTED)
                        .then(function (res) {
                            delete $scope.loading;
                            $scope.$digest();
                            $state.go("appLayout.harriSH.dashboard");
                        },
                        function (err) {
                            console.error(err);
                            delete $scope.loading;
                            $scope.$digest();
                            hAlert($filter("translate")("Something Went Wrong"), $filter("translate")("Please try again later"));
                        });
                }
                else {
                    delete $scope.loading;
                    $scope.$digest();
                }

            });
        };
    }]);
